export function camelCase(input: string) {
    return input?.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

export function pascalCase(input: string) {
    return input?.replace(/(^\w|_\w)/g, match => match.replace('_', '')?.toUpperCase());
}

export function formatWithCommas(input: number | string): string {
    const str = String(input);
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function titleCaseFromSnakeCase(input: string): string {
    const raw = (input ?? '').trim();
    if (!raw) {
        return '';
    }

    return raw
        .split('_')
        .filter((p) => p.length > 0)
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
        .join(' ');
}

export function truncateList(input: string[], maxLength: number = 2): string {
    if (input?.length === 0) {
        return '';
    }

    if (input?.length <= maxLength) {
        return input.join(', ');
    }

    return input.slice(0, maxLength).join(', ') + ',  & ' + (input.length - maxLength) + ' other' + (input.length - maxLength > 1 ? 's' : '');
}

// converts a string of format "{x,y}" for an array of strings
export function arrayStringToArray(str: string) {
    str = str.replace(/^\{|\}$/g, "");

    // handle empty
    if (!str.length) return [];

    return str.split(",");
}